import * as React from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { CarouselProps } from 'types/sharedComponents';

type CarouselContextProps = {
  carouselRef: ReturnType<typeof useEmblaCarousel>[0];
  api: ReturnType<typeof useEmblaCarousel>[1];
  scrollPrev: () => void;
  scrollNext: () => void;
  canScrollPrev: boolean;
  canScrollNext: boolean;
} & CarouselProps;

export const CarouselContext = React.createContext<CarouselContextProps | null>(null);

function useCarouselContext() {
  const context = React.useContext(CarouselContext);

  if (!context) {
    throw new Error('useCarouselContext must be used within a <Carousel />');
  }

  return context;
}

export default useCarouselContext;
